import { jwtDecode } from "jwt-decode";
import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
    CardTitle,
    Label,
    Button,
    Form,
} from "reactstrap";
import { toast } from "react-toastify";
import {
    getTodaysVisitsByClinicId2,
    getClinic,
    getPCAREByVisitId,
    addTakeLens,
    getvision,
    getVisionType,
    getJob,
    searchLensByLcode,
} from "service/api";
import { Link } from "react-router-dom";

const cardTopStyle = {
    backgroundColor: "#DC4C64",
    padding: "4px",
    color: "white",
    height: "30px",
};

const COATING_OPTIONS = [
    { value: "uc", label: "UC", priceKey: "uc" },
    { value: "hc", label: "HC", priceKey: "hc" },
    { value: "hmc_blue", label: "HMC Blue", priceKey: "hmc_blue" },
    { value: "shmc_blue", label: "SHMC Blue", priceKey: "shmc_blue" },
];

const COATING_KEY_MAP = {
    UC: "uc",
    HC: "hc",
    "HMC Blue": "hmc_blue",
    "SHMC Blue": "shmc_blue",
};

const TakeLenses = () => {
    // ── Auth ──
    const [clinicIdFromToken, setClinicIdFromToken] = useState(null);

    // ── Practice / Visit ──
    const [allcliniclist, setAllcliniclist] = useState([]);
    const [selectedClinic, setSelectedClinic] = useState("");
    const [allvisit, setAllvisit] = useState([]);
    const [selectedVisit, setSelectedVisit] = useState(null);
    const [loadingPcare, setLoadingPcare] = useState(false);
    const [pcareFound, setPcareFound] = useState(false);

    // ── Vision lookups ──
    const [visionList, setVisionList] = useState([]);
    const [visionTypeList, setVisionTypeList] = useState([]);
    // ── OD-specific ──
    const [filteredSubTypesOD, setFilteredSubTypesOD] = useState([]);
    const [selectedVisionIdOD, setSelectedVisionIdOD] = useState("");
    const [totalsOD, setTotalsOD] = useState({ uc: 0, hc: 0, hmc_blue: 0, shmc_blue: 0, photo: 0 });
    const [coatingPriceOD, setCoatingPriceOD] = useState(0);
    const [photoPriceOD, setPhotoPriceOD] = useState(0);
    const [isPhotochromicOD, setIsPhotochromicOD] = useState(false);
    // ── OS-specific ──
    const [filteredSubTypesOS, setFilteredSubTypesOS] = useState([]);
    const [selectedVisionIdOS, setSelectedVisionIdOS] = useState("");
    const [totalsOS, setTotalsOS] = useState({ uc: 0, hc: 0, hmc_blue: 0, shmc_blue: 0, photo: 0 });
    const [coatingPriceOS, setCoatingPriceOS] = useState(0);
    const [photoPriceOS, setPhotoPriceOS] = useState(0);
    const [isPhotochromicOS, setIsPhotochromicOS] = useState(false);
    const [isOSLensEditable, setIsOSLensEditable] = useState(false);
    const osLensEditCheckboxRef = useRef(null);
    const osPhotoCheckboxRef = useRef(null);

    // ── Lens form data ──
    const [lensData, setLensData] = useState({
        lens_code: "",
        lens_code_id: "",
        lens_material_od: "",
        lens_material_os: "",
        lens_vision_od: "",
        lens_vision_os: "",
        lens_subvision_od: "",
        lens_subvision_os: "",
        lens_type_od: "",
        lens_type_os: "",
        extra_od: "no",
        extra_os: "no",
    });

    const [saving, setSaving] = useState(false);

    // ── Registered Job mode ──
    const [hasRegisteredJob, setHasRegisteredJob] = useState(false);
    const [allJobs, setAllJobs] = useState([]);
    const [selectedJob, setSelectedJob] = useState(null);
    const [jobClinicId, setJobClinicId] = useState(null);
    // ── vc_reference selector for non-job mode ──
    const [selectedVCRefNoJob, setSelectedVCRefNoJob] = useState(null);
    const [lensCodeQuery, setLensCodeQuery] = useState("");
    const [lensSearchResults, setLensSearchResults] = useState([]);
    const [lensSearchLoading, setLensSearchLoading] = useState(false);
    const [lensSearchOpen, setLensSearchOpen] = useState(false);
    const lensSearchRef = useRef(null);

    // ── Fetch jobs on mount (used for both job mode and vc_reference search) ──
    useEffect(() => {
        getJob().then(res => setAllJobs(res?.data || [])).catch(() => { });
    }, []);

    // ── Decode token ──
    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setClinicIdFromToken(decoded?.clinicID || null);
            } catch (e) { /* ignore */ }
        }
    }, []);

    // ── Fetch vision + visionType ──
    useEffect(() => {
        getvision().then(res => setVisionList(res?.data || [])).catch(() => { });
        getVisionType().then(res => setVisionTypeList(res?.data || [])).catch(() => { });
    }, []);

    const syncCheckboxState = (checkboxRef, value) => {
        if (checkboxRef?.current) {
            checkboxRef.current.checked = value;
        }
    };

    useEffect(() => {
        syncCheckboxState(osLensEditCheckboxRef, isOSLensEditable);
    }, [isOSLensEditable]);

    useEffect(() => {
        syncCheckboxState(osPhotoCheckboxRef, isPhotochromicOS);
    }, [isPhotochromicOS]);

    useEffect(() => {
        const handler = (e) => {
            if (lensSearchRef.current && !lensSearchRef.current.contains(e.target)) {
                setLensSearchOpen(false);
            }
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    // ── Admin: fetch clinic list ──
    useEffect(() => {
        if (!clinicIdFromToken) {
            getClinic().then(res => setAllcliniclist(res?.data || [])).catch(() => { });
        }
    }, [clinicIdFromToken]);

    // ── Clinic login: auto-fetch visits ──
    useEffect(() => {
        if (clinicIdFromToken) fetchVisitsByClinic(clinicIdFromToken);
    }, [clinicIdFromToken]);

    const fetchVisitsByClinic = async (clinicId) => {
        try {
            const res = await getTodaysVisitsByClinicId2(clinicId);
            setAllvisit(res?.data || []);
        } catch (e) { setAllvisit([]); }
    };

    // ── Job toggle ──
    const handleJobToggle = (e) => {
        const checked = e.target.checked;
        setHasRegisteredJob(checked);
        setSelectedJob(null);
        setJobClinicId(null);
        setLensCodeQuery("");
        setLensSearchResults([]);
        setLensSearchOpen(false);
        setSelectedVCRefNoJob(null);
        setSelectedVisit(null);
        setPcareFound(false);
        resetLensData();
    };

    const handleJobSelect = (selected) => {
        setSelectedJob(selected);
        if (selected) {
            const j = selected.job;
            const cId = j.patientID?.clinicname?._id || clinicIdFromToken || null;
            setJobClinicId(cId);
        } else {
            setJobClinicId(null);
        }
    };

    // ── Admin: clinic dropdown change ──
    const handleClinicChange = (e) => {
        const clinicId = e.target.value;
        setSelectedClinic(clinicId);
        setAllvisit([]);
        setSelectedVisit(null);
        setPcareFound(false);
        if (clinicId) fetchVisitsByClinic(clinicId);
    };

    // ── vc_reference selected in non-job mode → fetch patientcare and auto-fill ──
    const handleVCRefNoJobChange = async (selected) => {
        setSelectedVCRefNoJob(selected);
        setPcareFound(false);
        resetLensData();
        if (!selected) { setSelectedVisit(null); return; }
        const j = selected.job;
        const visitId = j.visit?._id || j.visit;
        const cId = j.patientID?.clinicname?._id || clinicIdFromToken || null;
        if (cId) setSelectedClinic(cId);
        if (!visitId) return;
        setSelectedVisit({ value: visitId, label: j.vc_reference });
        setLoadingPcare(true);
        try {
            const res = await getPCAREByVisitId(visitId);
            const pcareList = res?.data;
            if (pcareList && pcareList.length > 0) {
                const pcare = pcareList[0];
                const visionIdOD = pcare.lens_vision_od?._id || pcare.lens_vision_od || pcare.lens_vision?._id || pcare.lens_vision || "";
                const subvisionIdOD = (pcare.lens_subvision_od?._id || pcare.lens_subvision_od || pcare.lens_subvision?._id || pcare.lens_subvision || "").toString();
                if (visionIdOD) {
                    const filtOD = visionTypeList.filter(vt => (vt.vision?._id || vt.vision)?.toString() === visionIdOD.toString());
                    setFilteredSubTypesOD(filtOD);
                    const matchOD = filtOD.find(vt => vt._id?.toString() === subvisionIdOD);
                    if (matchOD) {
                        const t = { uc: matchOD.uc ?? 0, hc: matchOD.hc ?? 0, hmc_blue: matchOD.hmc_blue ?? 0, shmc_blue: matchOD.shmc_blue ?? 0, photo: matchOD.photo ?? 0 };
                        setTotalsOD(t);
                        const coatingKey = pcare.lens_type_od || pcare.type || "";
                        setCoatingPriceOD(coatingKey ? (parseFloat(t[coatingKey]) || 0) : 0);
                        const isPhotoOD = (pcare.extra_od || pcare.extra) === "yes";
                        setPhotoPriceOD(isPhotoOD ? (parseFloat(t.photo) || 0) : 0);
                        setIsPhotochromicOD(isPhotoOD);
                    }
                }
                setSelectedVisionIdOD(visionIdOD);
                const visionIdOS =
                    pcare.lens_vision_os?._id ||
                    pcare.lens_vision_os ||
                    pcare.lens_vision?._id ||
                    pcare.lens_vision ||
                    visionIdOD ||
                    "";
                const subvisionIdOS = (
                    pcare.lens_subvision_os?._id ||
                    pcare.lens_subvision_os ||
                    pcare.lens_subvision?._id ||
                    pcare.lens_subvision ||
                    subvisionIdOD ||
                    ""
                ).toString();
                if (visionIdOS) {
                    const filtOS = visionTypeList.filter(vt => (vt.vision?._id || vt.vision)?.toString() === visionIdOS.toString());
                    setFilteredSubTypesOS(filtOS);
                    const matchOS = filtOS.find(vt => vt._id?.toString() === subvisionIdOS);
                    if (matchOS) {
                        const t = { uc: matchOS.uc ?? 0, hc: matchOS.hc ?? 0, hmc_blue: matchOS.hmc_blue ?? 0, shmc_blue: matchOS.shmc_blue ?? 0, photo: matchOS.photo ?? 0 };
                        setTotalsOS(t);
                        const coatingKeyOS = pcare.lens_type_os || pcare.type || pcare.lens_type_od || "";
                        setCoatingPriceOS(coatingKeyOS ? (parseFloat(t[coatingKeyOS]) || 0) : 0);
                        const isPhotoOS = (pcare.extra_os || pcare.extra || pcare.extra_od) === "yes";
                        setPhotoPriceOS(isPhotoOS ? (parseFloat(t.photo) || 0) : 0);
                        setIsPhotochromicOS(isPhotoOS);
                    }
                }
                setSelectedVisionIdOS(visionIdOS);
                setLensData({
                    lens_code: pcare.lens_code || "",
                    lens_code_id: pcare.lens_code_id?._id || pcare.lens_code_id || "",
                    lens_material_od: pcare.lens_material_od || pcare.lens_material || pcare.material || "",
                    lens_material_os: pcare.lens_material_os || pcare.lens_material || pcare.material || "",
                    lens_vision_od: visionIdOD,
                    lens_vision_os: visionIdOS,
                    lens_subvision_od: subvisionIdOD,
                    lens_subvision_os: subvisionIdOS,
                    lens_type_od: pcare.lens_type_od || pcare.type || "",
                    lens_type_os: pcare.lens_type_os || pcare.type || pcare.lens_type_od || "",
                    extra_od: pcare.extra_od || pcare.extra || "no",
                    extra_os: pcare.extra_os || pcare.extra || pcare.extra_od || "no",
                });
                setPcareFound(true);
            }
        } catch (e) { /* no pcare */ } finally {
            setLoadingPcare(false);
        }
    };

    // ── Visit selected → fetch patientcare and auto-fill ──
    const handleVisitChange = async (selected) => {
        setSelectedVisit(selected);
        setPcareFound(false);
        resetLensData();
        if (!selected) return;

        setLoadingPcare(true);
        try {
            const res = await getPCAREByVisitId(selected.value);
            const pcareList = res?.data;
            if (pcareList && pcareList.length > 0) {
                const pcare = pcareList[0];

                // ── OD ──
                const visionIdOD = pcare.lens_vision_od?._id || pcare.lens_vision_od || pcare.lens_vision?._id || pcare.lens_vision || "";
                const subvisionIdOD = (pcare.lens_subvision_od?._id || pcare.lens_subvision_od || pcare.lens_subvision?._id || pcare.lens_subvision || "").toString();
                if (visionIdOD) {
                    const filtOD = visionTypeList.filter(vt => (vt.vision?._id || vt.vision)?.toString() === visionIdOD.toString());
                    setFilteredSubTypesOD(filtOD);
                    const matchOD = filtOD.find(vt => vt._id?.toString() === subvisionIdOD);
                    if (matchOD) {
                        const t = { uc: matchOD.uc ?? 0, hc: matchOD.hc ?? 0, hmc_blue: matchOD.hmc_blue ?? 0, shmc_blue: matchOD.shmc_blue ?? 0, photo: matchOD.photo ?? 0 };
                        setTotalsOD(t);
                        const coatingKey = pcare.lens_type_od || pcare.type || "";
                        setCoatingPriceOD(coatingKey ? (parseFloat(t[coatingKey]) || 0) : 0);
                        const isPhotoOD = (pcare.extra_od || pcare.extra) === "yes";
                        setPhotoPriceOD(isPhotoOD ? (parseFloat(t.photo) || 0) : 0);
                        setIsPhotochromicOD(isPhotoOD);
                    }
                }
                setSelectedVisionIdOD(visionIdOD);

                // ── OS ──
                const visionIdOS =
                    pcare.lens_vision_os?._id ||
                    pcare.lens_vision_os ||
                    pcare.lens_vision?._id ||
                    pcare.lens_vision ||
                    visionIdOD ||
                    "";
                const subvisionIdOS = (
                    pcare.lens_subvision_os?._id ||
                    pcare.lens_subvision_os ||
                    pcare.lens_subvision?._id ||
                    pcare.lens_subvision ||
                    subvisionIdOD ||
                    ""
                ).toString();
                if (visionIdOS) {
                    const filtOS = visionTypeList.filter(vt => (vt.vision?._id || vt.vision)?.toString() === visionIdOS.toString());
                    setFilteredSubTypesOS(filtOS);
                    const matchOS = filtOS.find(vt => vt._id?.toString() === subvisionIdOS);
                    if (matchOS) {
                        const t = { uc: matchOS.uc ?? 0, hc: matchOS.hc ?? 0, hmc_blue: matchOS.hmc_blue ?? 0, shmc_blue: matchOS.shmc_blue ?? 0, photo: matchOS.photo ?? 0 };
                        setTotalsOS(t);
                        const coatingKeyOS = pcare.lens_type_os || pcare.type || pcare.lens_type_od || "";
                        setCoatingPriceOS(coatingKeyOS ? (parseFloat(t[coatingKeyOS]) || 0) : 0);
                        const isPhotoOS = (pcare.extra_os || pcare.extra || pcare.extra_od) === "yes";
                        setPhotoPriceOS(isPhotoOS ? (parseFloat(t.photo) || 0) : 0);
                        setIsPhotochromicOS(isPhotoOS);
                    }
                }
                setSelectedVisionIdOS(visionIdOS);

                setLensData({
                    lens_code: pcare.lens_code || "",
                    lens_code_id: pcare.lens_code_id?._id || pcare.lens_code_id || "",
                    lens_material_od: pcare.lens_material_od || pcare.lens_material || pcare.material || "",
                    lens_material_os: pcare.lens_material_os || pcare.lens_material || pcare.material || "",
                    lens_vision_od: visionIdOD,
                    lens_vision_os: visionIdOS,
                    lens_subvision_od: subvisionIdOD,
                    lens_subvision_os: subvisionIdOS,
                    lens_type_od: pcare.lens_type_od || pcare.type || "",
                    lens_type_os: pcare.lens_type_os || pcare.type || pcare.lens_type_od || "",
                    extra_od: pcare.extra_od || pcare.extra || "no",
                    extra_os: pcare.extra_os || pcare.extra || pcare.extra_od || "no",
                });
                setPcareFound(true);
            }
        } catch (e) {
            // no pcare found
        } finally {
            setLoadingPcare(false);
        }
    };

    const resetLensData = () => {
        setLensData({ lens_code: "", lens_code_id: "", lens_material_od: "", lens_material_os: "", lens_vision_od: "", lens_vision_os: "", lens_subvision_od: "", lens_subvision_os: "", lens_type_od: "", lens_type_os: "", extra_od: "no", extra_os: "no" });
        setSelectedVisionIdOD(""); setFilteredSubTypesOD([]); setTotalsOD({ uc: 0, hc: 0, hmc_blue: 0, shmc_blue: 0, photo: 0 }); setCoatingPriceOD(0); setPhotoPriceOD(0); setIsPhotochromicOD(false);
        setSelectedVisionIdOS(""); setFilteredSubTypesOS([]); setTotalsOS({ uc: 0, hc: 0, hmc_blue: 0, shmc_blue: 0, photo: 0 }); setCoatingPriceOS(0); setPhotoPriceOS(0); setIsPhotochromicOS(false); setIsOSLensEditable(false);
    };

    const handleLensCodeSearch = async (query) => {
        setLensCodeQuery(query);
        if (!query.trim()) {
            setLensSearchResults([]);
            setLensSearchOpen(false);
            return;
        }

        const clinicId = jobClinicId || clinicIdFromToken || selectedClinic || "";
        if (!clinicId) {
            setLensSearchResults([]);
            setLensSearchOpen(false);
            return;
        }

        setLensSearchLoading(true);
        try {
            const res = await searchLensByLcode(query.trim(), clinicId);
            setLensSearchResults(res?.data || []);
            setLensSearchOpen(true);
        } catch (error) {
            console.error("Lens search error:", error);
            setLensSearchResults([]);
            setLensSearchOpen(true);
        } finally {
            setLensSearchLoading(false);
        }
    };

    const handleLensCodeSelect = (stockItem) => {
        const lensDoc = stockItem?.lname_id;
        if (!lensDoc) return;

        const visionId = (lensDoc.lens_vision?._id || lensDoc.lens_vision || "").toString();
        const subType = lensDoc.sub_type || lensDoc.lens_subvision_name || "";
        const coatKey = COATING_KEY_MAP[lensDoc.lens_type] || lensDoc.lens_type || "";
        const material = lensDoc.lens_material || "";
        const normalizedMaterial = ["CR-39(Plastic)", "Polycarbonate", "Glass", "Uncut"].find(
            item => item.toLowerCase() === material.toLowerCase()
        ) || material;
        const lensCode = stockItem.lcode || lensDoc.lens_code || "";
        const lensCodeId = lensDoc._id || "";

        const filteredTypes = visionTypeList.filter(
            vt => (vt.vision?._id || vt.vision)?.toString() === visionId
        );
        const matchedSubType = filteredTypes.find(vt => vt.sub_type === subType) || null;
        const totals = matchedSubType
            ? {
                uc: matchedSubType.uc ?? 0,
                hc: matchedSubType.hc ?? 0,
                hmc_blue: matchedSubType.hmc_blue ?? 0,
                shmc_blue: matchedSubType.shmc_blue ?? 0,
                photo: matchedSubType.photo ?? 0,
            }
            : { uc: 0, hc: 0, hmc_blue: 0, shmc_blue: 0, photo: 0 };

        setIsOSLensEditable(false);
        setSelectedVisionIdOD(visionId);
        setSelectedVisionIdOS(visionId);
        setFilteredSubTypesOD(filteredTypes);
        setFilteredSubTypesOS(filteredTypes);
        setTotalsOD(totals);
        setTotalsOS(totals);
        setIsPhotochromicOD(false);
        setIsPhotochromicOS(false);
        setPhotoPriceOD(0);
        setPhotoPriceOS(0);
        setCoatingPriceOD(coatKey ? (parseFloat(totals[coatKey]) || 0) : 0);
        setCoatingPriceOS(coatKey ? (parseFloat(totals[coatKey]) || 0) : 0);
        setLensData(prev => ({
            ...prev,
            lens_code: lensCode,
            lens_code_id: lensCodeId,
            lens_material_od: normalizedMaterial,
            lens_material_os: normalizedMaterial,
            lens_vision_od: visionId,
            lens_vision_os: visionId,
            lens_subvision_od: matchedSubType?._id || "",
            lens_subvision_os: matchedSubType?._id || "",
            lens_type_od: coatKey,
            lens_type_os: coatKey,
            extra_od: "no",
            extra_os: "no",
        }));

        setLensCodeQuery(lensCode);
        setLensSearchResults([]);
        setLensSearchOpen(false);
    };

    // ── OD handlers ──
    const handleMaterialChangeOD = (e) => {
        const value = e.target.value;
        setLensData(prev => ({
            ...prev,
            lens_material_od: value,
            lens_material_os: !isOSLensEditable ? value : prev.lens_material_os,
        }));
    };

    const handleVisionChangeOD = (e) => {
        const vId = e.target.value;
        setSelectedVisionIdOD(vId);
        const filtered = visionTypeList.filter(vt => (vt.vision?._id || vt.vision)?.toString() === vId.toString());
        setFilteredSubTypesOD(filtered);
        setTotalsOD({ uc: 0, hc: 0, hmc_blue: 0, shmc_blue: 0, photo: 0 });
        setCoatingPriceOD(0); setPhotoPriceOD(0);
        setLensData(prev => ({
            ...prev,
            lens_vision_od: vId,
            lens_subvision_od: "",
            lens_type_od: "",
            ...(isOSLensEditable ? {} : { lens_vision_os: vId, lens_subvision_os: "", lens_type_os: "", extra_os: "no" }),
        }));
        if (!isOSLensEditable) {
            setSelectedVisionIdOS(vId);
            setFilteredSubTypesOS(filtered);
            setTotalsOS({ uc: 0, hc: 0, hmc_blue: 0, shmc_blue: 0, photo: 0 });
            setCoatingPriceOS(0);
            setPhotoPriceOS(0);
            setIsPhotochromicOS(false);
        }
    };

    const handleSubvisionChangeOD = (e) => {
        const subId = e.target.value;
        const matched = filteredSubTypesOD.find(vt => vt._id?.toString() === subId);
        if (matched) {
            const t = { uc: matched.uc ?? 0, hc: matched.hc ?? 0, hmc_blue: matched.hmc_blue ?? 0, shmc_blue: matched.shmc_blue ?? 0, photo: matched.photo ?? 0 };
            setTotalsOD(t);
            const cp = lensData.lens_type_od ? (parseFloat(t[lensData.lens_type_od]) || 0) : 0;
            const pp = isPhotochromicOD ? (parseFloat(t.photo) || 0) : 0;
            setCoatingPriceOD(cp); setPhotoPriceOD(pp);
        }
        setLensData(prev => ({
            ...prev,
            lens_subvision_od: subId,
            ...(isOSLensEditable ? {} : { lens_subvision_os: subId, lens_type_os: prev.lens_type_od, extra_os: isPhotochromicOD ? "yes" : "no" }),
        }));
        if (!isOSLensEditable && matched) {
            setTotalsOS({ uc: matched.uc ?? 0, hc: matched.hc ?? 0, hmc_blue: matched.hmc_blue ?? 0, shmc_blue: matched.shmc_blue ?? 0, photo: matched.photo ?? 0 });
            setCoatingPriceOS(lensData.lens_type_od ? (parseFloat(matched[lensData.lens_type_od]) || 0) : 0);
            setPhotoPriceOS(isPhotochromicOD ? (parseFloat(matched.photo) || 0) : 0);
        }
    };

    const handleCoatingChangeOD = (e) => {
        const val = e.target.value;
        setCoatingPriceOD(parseFloat(totalsOD[val]) || 0);
        setLensData(prev => ({ ...prev, lens_type_od: val, ...(isOSLensEditable ? {} : { lens_type_os: val }) }));
        if (!isOSLensEditable) {
            setCoatingPriceOS(parseFloat(totalsOD[val]) || 0);
        }
    };

    const handlePhotochromicChangeOD = () => {
        const newVal = !isPhotochromicOD;
        setIsPhotochromicOD(newVal);
        setPhotoPriceOD(newVal ? (parseFloat(totalsOD.photo) || 0) : 0);
        setLensData(prev => ({ ...prev, extra_od: newVal ? "yes" : "no", ...(isOSLensEditable ? {} : { extra_os: newVal ? "yes" : "no" }) }));
        if (!isOSLensEditable) {
            setIsPhotochromicOS(newVal);
            setPhotoPriceOS(newVal ? (parseFloat(totalsOD.photo) || 0) : 0);
        }
    };

    const handleOSLensEditToggle = () => {
        const nextEditable = !isOSLensEditable;
        setIsOSLensEditable(nextEditable);

        if (!nextEditable) {
            setSelectedVisionIdOS(selectedVisionIdOD);
            setFilteredSubTypesOS(filteredSubTypesOD);
            setTotalsOS(totalsOD);
            setCoatingPriceOS(coatingPriceOD);
            setPhotoPriceOS(photoPriceOD);
            setIsPhotochromicOS(isPhotochromicOD);
            setLensData(prev => ({
                ...prev,
                lens_material_os: prev.lens_material_od,
                lens_vision_os: prev.lens_vision_od,
                lens_subvision_os: prev.lens_subvision_od,
                lens_type_os: prev.lens_type_od,
                extra_os: prev.extra_od,
            }));
        }
    };

    // ── OS handlers ──
    const handleVisionChangeOS = (e) => {
        const vId = e.target.value;
        setSelectedVisionIdOS(vId);
        const filtered = visionTypeList.filter(vt => (vt.vision?._id || vt.vision)?.toString() === vId.toString());
        setFilteredSubTypesOS(filtered);
        setTotalsOS({ uc: 0, hc: 0, hmc_blue: 0, shmc_blue: 0, photo: 0 });
        setCoatingPriceOS(0); setPhotoPriceOS(0);
        setLensData(prev => ({ ...prev, lens_vision_os: vId, lens_subvision_os: "", lens_type_os: "" }));
    };

    const handleSubvisionChangeOS = (e) => {
        const subId = e.target.value;
        const matched = filteredSubTypesOS.find(vt => vt._id?.toString() === subId);
        if (matched) {
            const t = { uc: matched.uc ?? 0, hc: matched.hc ?? 0, hmc_blue: matched.hmc_blue ?? 0, shmc_blue: matched.shmc_blue ?? 0, photo: matched.photo ?? 0 };
            setTotalsOS(t);
            const cp = lensData.lens_type_os ? (parseFloat(t[lensData.lens_type_os]) || 0) : 0;
            const pp = isPhotochromicOS ? (parseFloat(t.photo) || 0) : 0;
            setCoatingPriceOS(cp); setPhotoPriceOS(pp);
        }
        setLensData(prev => ({ ...prev, lens_subvision_os: subId }));
    };

    const handleCoatingChangeOS = (e) => {
        const val = e.target.value;
        setCoatingPriceOS(parseFloat(totalsOS[val]) || 0);
        setLensData(prev => ({ ...prev, lens_type_os: val }));
    };

    const handlePhotochromicChangeOS = () => {
        const newVal = !isPhotochromicOS;
        setIsPhotochromicOS(newVal);
        setPhotoPriceOS(newVal ? (parseFloat(totalsOS.photo) || 0) : 0);
        setLensData(prev => ({ ...prev, extra_os: newVal ? "yes" : "no" }));
    };

    // ── Save ──
    const handleSave = async () => {
        if (hasRegisteredJob) {
            if (!selectedJob) { toast.error("Please select a registered job."); return; }
            setSaving(true);
            try {
                const clinicId = jobClinicId || clinicIdFromToken || undefined;
                const payload = {
                    ...lensData,
                    ...(clinicId ? { clinic_id: clinicId } : {}),
                    visit_no: selectedJob.job?.vc_reference || "",
                    job_id: selectedJob.value,
                    job_vc_reference: selectedJob.job?.vc_reference || "",
                };
                if (!payload.lens_code_id) delete payload.lens_code_id;
                await addTakeLens(payload);
                toast.success("Lens record saved successfully!");
                resetLensData();
                setSelectedJob(null);
                setJobClinicId(null);
            } catch (e) {
                toast.error("Failed to save lens record.");
            } finally {
                setSaving(false);
            }
            return;
        }

        if (!selectedVisit) { toast.error("Please select a visit first."); return; }
        const clinicId = clinicIdFromToken || selectedClinic;
        if (!clinicId) { toast.error("Please select a practice."); return; }

        setSaving(true);
        try {
            const payload = {
                ...lensData,
                clinic_id: clinicId,
                visit_id: selectedVisit.value,
                visit_no: selectedVisit.label.split(" — ")[0],
            };
            if (!payload.lens_code_id) delete payload.lens_code_id;
            await addTakeLens(payload);
            toast.success("Lens record saved successfully!");
            resetLensData();
            setSelectedVisit(null);
            setPcareFound(false);
        } catch (e) {
            toast.error("Failed to save lens record.");
        } finally {
            setSaving(false);
        }
    };

    const visitOptions = allvisit.map(v => ({
        value: v._id,
        label: `${v.visit_no}${v.patientid ? " — " + (v.patientid.firstname || "") + " " + (v.patientid.lastname || "") : ""}`,
    }));

    const grandTotal = coatingPriceOD + photoPriceOD + coatingPriceOS + photoPriceOS;

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h4 className="page-title">Lens Selection</h4>
                        <Link to="/list-takelens" className="btn btn-danger">
                            <i className="mdi mdi-format-list-bulleted me-1" />List
                        </Link>
                    </div>

                    <Row>
                        <Card>
                            <CardBody>

                                {/* ── Registered Job Toggle ── */}
                                <Row className="mb-3">
                                    <Col md={12}>
                                        <div className="d-flex align-items-center" style={{ padding: "6px 0" }}>
                                            <div className="form-check form-switch mb-0">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="lensJobToggle"
                                                    checked={hasRegisteredJob}
                                                    onChange={handleJobToggle}
                                                    style={{ width: 40, height: 20, cursor: "pointer" }}
                                                />
                                                <label className="form-check-label ms-2" htmlFor="lensJobToggle" style={{ fontSize: 14, fontWeight: 600 }}>
                                                    Do you have a registered job?
                                                </label>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>

                                {hasRegisteredJob ? (
                                    <>
                                        <div style={cardTopStyle}>
                                            <CardTitle className="mb-0">Select Registered Job</CardTitle>
                                        </div>
                                        <br />
                                        <Row className="mb-4">
                                            <Col md={5}>
                                                <Label>Job Reference</Label>
                                                <Select
                                                    options={allJobs.map(j => ({
                                                        value: j._id,
                                                        label: `${j.vc_reference || j._id} — ${j.patient_name || ""}`,
                                                        job: j,
                                                    }))}
                                                    value={selectedJob}
                                                    onChange={handleJobSelect}
                                                    placeholder="Search by job reference or patient name..."
                                                    isClearable
                                                />
                                            </Col>
                                            {selectedJob && (
                                                <Col md={5} className="d-flex align-items-end">
                                                    <span className="text-success" style={{ fontSize: 13, fontWeight: 600 }}>
                                                        <i className="mdi mdi-briefcase-check me-1" />
                                                        Job: {selectedJob.job?.vc_reference} &nbsp;|&nbsp; Practice: {selectedJob.job?.practisc_name || "—"}
                                                    </span>
                                                </Col>
                                            )}
                                        </Row>
                                        <Row className="mb-4">
                                            <Col md={5}>
                                                <Label>Search Lens by Code</Label>
                                                <div ref={lensSearchRef} style={{ position: "relative" }}>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={lensCodeQuery}
                                                        onChange={(e) => handleLensCodeSearch(e.target.value)}
                                                        placeholder={jobClinicId || clinicIdFromToken ? "Type lens code..." : "Select a job first..."}
                                                        disabled={!selectedJob && !clinicIdFromToken}
                                                        autoComplete="off"
                                                    />
                                                    {lensSearchOpen && (
                                                        <div
                                                            style={{
                                                                position: "absolute",
                                                                top: "100%",
                                                                left: 0,
                                                                right: 0,
                                                                zIndex: 20,
                                                                background: "#fff",
                                                                border: "1px solid #ddd",
                                                                borderTop: "none",
                                                                borderRadius: "0 0 6px 6px",
                                                                maxHeight: 220,
                                                                overflowY: "auto",
                                                                boxShadow: "0 6px 16px rgba(0,0,0,0.08)",
                                                            }}
                                                        >
                                                            {lensSearchLoading ? (
                                                                <div style={{ padding: 10, fontSize: 13, color: "#666" }}>Searching...</div>
                                                            ) : lensSearchResults.length > 0 ? (
                                                                lensSearchResults.map((item) => {
                                                                    const doc = item.lname_id;
                                                                    return (
                                                                        <div
                                                                            key={item._id}
                                                                            onMouseDown={() => handleLensCodeSelect(item)}
                                                                            style={{
                                                                                padding: "10px 12px",
                                                                                cursor: "pointer",
                                                                                borderBottom: "1px solid #f2f2f2",
                                                                            }}
                                                                        >
                                                                            <div style={{ fontWeight: 600, fontSize: 13 }}>{item.lcode || doc?.lens_code || "-"}</div>
                                                                            <div style={{ fontSize: 12, color: "#666" }}>
                                                                                {[doc?.lens_material, doc?.sub_type, doc?.lens_type].filter(Boolean).join(" | ")}
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })
                                                            ) : (
                                                                <div style={{ padding: 10, fontSize: 13, color: "#666" }}>No lens found</div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                    </>
                                ) : (
                                    <>
                                        {/* ── Visit Search ── */}
                                        <div style={cardTopStyle}>
                                            <CardTitle className="mb-0">Select Visit</CardTitle>
                                        </div>
                                        <br />
                                        <Row className="mb-4">
                                            {!clinicIdFromToken && (
                                                <Col md={4}>
                                                    <Label>Practice</Label>
                                                    <select
                                                        className="form-control"
                                                        value={selectedClinic}
                                                        onChange={handleClinicChange}
                                                    >
                                                        <option value="">Select Practice</option>
                                                        {allcliniclist.map(c => (
                                                            <option key={c._id} value={c._id}>{c.name}</option>
                                                        ))}
                                                    </select>
                                                </Col>
                                            )}
                                            <Col md={4}>
                                                <Label>Visit No.</Label>
                                                <Select
                                                    options={visitOptions}
                                                    value={selectedVisit}
                                                    onChange={handleVisitChange}
                                                    placeholder={!clinicIdFromToken && !selectedClinic ? "Select a practice first..." : "Search and select visit..."}
                                                    isClearable
                                                    isDisabled={!clinicIdFromToken && !selectedClinic}
                                                />
                                            </Col>
                                            <Col md={4} className="d-flex align-items-end">
                                                {loadingPcare && (
                                                    <span className="text-muted" style={{ fontSize: 13 }}>
                                                        <span className="spinner-border spinner-border-sm me-1" />
                                                        Loading patient care data...
                                                    </span>
                                                )}
                                                {!loadingPcare && pcareFound && (
                                                    <span className="text-success" style={{ fontSize: 13, fontWeight: 600 }}>
                                                        <i className="mdi mdi-check-circle me-1" />
                                                        Lens data auto-populated from patient care record
                                                    </span>
                                                )}
                                                {!loadingPcare && selectedVisit && !pcareFound && (
                                                    <span className="text-warning" style={{ fontSize: 13 }}>
                                                        <i className="mdi mdi-alert-outline me-1" />
                                                        No patient care record found for this visit
                                                    </span>
                                                )}
                                            </Col>
                                        </Row>
                                    </>
                                )}

                                {/* ── Lens Details Form ── */}
                                <div style={cardTopStyle}>
                                    <CardTitle className="mb-0">Lens Details</CardTitle>
                                </div>
                                <br />
                                <Form>
                                    <Row>
                                        {/* ── OD (Right Eye) ── */}
                                        <Col md={6}>
                                            <div style={{ background: "#fff8f8", border: "1px solid #f5c6c6", borderRadius: 8, padding: "16px", marginBottom: 16 }}>
                                                <div style={{ fontWeight: 700, color: "#C62828", marginBottom: 14, fontSize: 13 }}>
                                                    <i className="mdi mdi-eye-outline me-1" /> OD [Right Eye]
                                                </div>
                                                <Row>
                                                    <Col md={6}>
                                                        <div className="mb-3">
                                                            <Label style={{ fontSize: 12, fontWeight: 600 }}>Lens Category :</Label>
                                                            <select className="form-control form-control-sm" value={lensData.lens_material_od} onChange={handleMaterialChangeOD}>
                                                                <option value="">Select</option>
                                                                <option>CR-39(Plastic)</option>
                                                                <option>Polycarbonate</option>
                                                                <option>Glass</option>
                                                                <option>Uncut</option>
                                                            </select>
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="mb-3">
                                                            <Label style={{ fontSize: 12, fontWeight: 600 }}>1. Vision Category :</Label>
                                                            <select className="form-control form-control-sm" value={selectedVisionIdOD} onChange={handleVisionChangeOD}>
                                                                <option value="">— Select Vision —</option>
                                                                {visionList.map(v => (<option key={v._id} value={v._id}>{v.vision}</option>))}
                                                            </select>
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="mb-3">
                                                            <Label style={{ fontSize: 12, fontWeight: 600 }}>2. Sub-Type :</Label>
                                                            <select className="form-control form-control-sm" value={lensData.lens_subvision_od} onChange={handleSubvisionChangeOD} disabled={!selectedVisionIdOD}>
                                                                <option value="">— Select —</option>
                                                                {[...new Set(filteredSubTypesOD.map(vt => vt.sub_type).filter(Boolean))].map(st => {
                                                                    const rec = filteredSubTypesOD.find(vt => vt.sub_type === st);
                                                                    return <option key={rec._id} value={rec._id}>{st}</option>;
                                                                })}
                                                            </select>
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="mb-3">
                                                            <Label style={{ fontSize: 12, fontWeight: 600 }}>3. Lens Coating :</Label>
                                                            <div className="d-flex flex-wrap" style={{ gap: 6, marginTop: 4 }}>
                                                                {COATING_OPTIONS.map(opt => (
                                                                    <div key={opt.value} className="form-check form-radio-danger" style={{ marginRight: 4 }}>
                                                                        <input className="form-check-input" type="radio" name="lens_type_od" id={`ltod_${opt.value}`} value={opt.value} checked={lensData.lens_type_od === opt.value} onChange={handleCoatingChangeOD} disabled={!lensData.lens_subvision_od} />
                                                                        <label className="form-check-label" htmlFor={`ltod_${opt.value}`} style={{ fontSize: 12 }}>
                                                                            {opt.label}
                                                                            {lensData.lens_subvision_od && totalsOD[opt.value] ? <span style={{ color: "#DC4C64", fontSize: 10, marginLeft: 2 }}>R{parseFloat(totalsOD[opt.value]).toFixed(2)}</span> : null}
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col md={12}>
                                                        <div className="mb-2 d-flex align-items-center" style={{ gap: 8 }}>
                                                            <input type="checkbox" id="photo_od" checked={isPhotochromicOD} onClick={handlePhotochromicChangeOD} onChange={() => { }} disabled={!lensData.lens_subvision_od} style={{ width: 15, height: 15, accentColor: "#DC4C64", cursor: "pointer" }} />
                                                            <label htmlFor="photo_od" style={{ margin: 0, fontSize: 12, fontWeight: 500 }}>
                                                                Photochromic {lensData.lens_subvision_od && totalsOD.photo ? <span style={{ color: "#DC4C64", fontSize: 11 }}>(+R{parseFloat(totalsOD.photo).toFixed(2)})</span> : null}
                                                            </label>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                {(lensData.lens_type_od || isPhotochromicOD) && (
                                                    <div style={{ borderTop: "1px solid #f5c6c6", paddingTop: 8, marginTop: 4, fontSize: 12, textAlign: "right", color: "#DC4C64", fontWeight: 700 }}>
                                                        OD Total: R {(coatingPriceOD + photoPriceOD).toFixed(2)}
                                                    </div>
                                                )}
                                            </div>
                                        </Col>

                                        {/* ── OS (Left Eye) ── */}
                                        <Col md={6}>
                                            <div style={{ background: "#f8f8ff", border: "1px solid #c6c6f5", borderRadius: 8, padding: "16px", marginBottom: 16 }}>
                                                <div style={{ fontWeight: 700, color: "#2828C6", marginBottom: 14, fontSize: 13 }}>
                                                    <i className="mdi mdi-eye-outline me-1" /> OS [Left Eye]
                                                </div>
                                                <div className="mb-3">
                                                    <div className="d-flex align-items-center" style={{ gap: 8 }}>
                                                        <input
                                                            type="checkbox"
                                                            id="enable_os_lens_edit_take"
                                                            ref={osLensEditCheckboxRef}
                                                            defaultChecked={isOSLensEditable}
                                                            onClick={handleOSLensEditToggle}
                                                            style={{ width: 15, height: 15, cursor: "pointer" }}
                                                        />
                                                        <label htmlFor="enable_os_lens_edit_take" style={{ margin: 0, fontSize: 12, fontWeight: 500, color: "#2828C6", cursor: "pointer" }}>
                                                            Allow changes in OS lens selection
                                                        </label>
                                                    </div>
                                                </div>
                                                <Row>
                                                    <Col md={6}>
                                                        <div className="mb-3">
                                                            <Label style={{ fontSize: 12, fontWeight: 600 }}>Lens Category :</Label>
                                                            <select className="form-control form-control-sm" value={lensData.lens_material_os} onChange={e => setLensData(prev => ({ ...prev, lens_material_os: e.target.value }))} disabled={!isOSLensEditable}>
                                                                <option value="">Select</option>
                                                                <option>CR-39(Plastic)</option>
                                                                <option>Polycarbonate</option>
                                                                <option>Glass</option>
                                                                <option>Uncut</option>
                                                            </select>
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="mb-3">
                                                            <Label style={{ fontSize: 12, fontWeight: 600 }}>1. Vision Category :</Label>
                                                            <select className="form-control form-control-sm" value={selectedVisionIdOS} onChange={handleVisionChangeOS} disabled={!isOSLensEditable}>
                                                                <option value="">— Select Vision —</option>
                                                                {visionList.map(v => (<option key={v._id} value={v._id}>{v.vision}</option>))}
                                                            </select>
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="mb-3">
                                                            <Label style={{ fontSize: 12, fontWeight: 600 }}>2. Sub-Type :</Label>
                                                            <select className="form-control form-control-sm" value={lensData.lens_subvision_os} onChange={handleSubvisionChangeOS} disabled={!isOSLensEditable || !selectedVisionIdOS}>
                                                                <option value="">— Select —</option>
                                                                {[...new Set(filteredSubTypesOS.map(vt => vt.sub_type).filter(Boolean))].map(st => {
                                                                    const rec = filteredSubTypesOS.find(vt => vt.sub_type === st);
                                                                    return <option key={rec._id} value={rec._id}>{st}</option>;
                                                                })}
                                                            </select>
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className="mb-3">
                                                            <Label style={{ fontSize: 12, fontWeight: 600 }}>3. Lens Coating :</Label>
                                                            <div className="d-flex flex-wrap" style={{ gap: 6, marginTop: 4 }}>
                                                                {COATING_OPTIONS.map(opt => (
                                                                    <div key={opt.value} className="form-check form-radio-danger" style={{ marginRight: 4 }}>
                                                                        <input className="form-check-input" type="radio" name="lens_type_os" id={`ltos_${opt.value}`} value={opt.value} checked={lensData.lens_type_os === opt.value} onChange={handleCoatingChangeOS} disabled={!isOSLensEditable || !lensData.lens_subvision_os} />
                                                                        <label className="form-check-label" htmlFor={`ltos_${opt.value}`} style={{ fontSize: 12 }}>
                                                                            {opt.label}
                                                                            {lensData.lens_subvision_os && totalsOS[opt.value] ? <span style={{ color: "#2828C6", fontSize: 10, marginLeft: 2 }}>R{parseFloat(totalsOS[opt.value]).toFixed(2)}</span> : null}
                                                                        </label>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col md={12}>
                                                        <div className="mb-2 d-flex align-items-center" style={{ gap: 8 }}>
                                                            <input type="checkbox" id="photo_os" ref={osPhotoCheckboxRef} defaultChecked={isPhotochromicOS} onClick={handlePhotochromicChangeOS} onChange={() => { }} disabled={!isOSLensEditable || !lensData.lens_subvision_os} style={{ width: 15, height: 15, accentColor: "#2828C6", cursor: "pointer" }} />
                                                            <label htmlFor="photo_os" style={{ margin: 0, fontSize: 12, fontWeight: 500 }}>
                                                                Photochromic {lensData.lens_subvision_os && totalsOS.photo ? <span style={{ color: "#2828C6", fontSize: 11 }}>(+R{parseFloat(totalsOS.photo).toFixed(2)})</span> : null}
                                                            </label>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                {(lensData.lens_type_os || isPhotochromicOS) && (
                                                    <div style={{ borderTop: "1px solid #c6c6f5", paddingTop: 8, marginTop: 4, fontSize: 12, textAlign: "right", color: "#2828C6", fontWeight: 700 }}>
                                                        OS Total: R {(coatingPriceOS + photoPriceOS).toFixed(2)}
                                                    </div>
                                                )}
                                            </div>
                                        </Col>
                                    </Row>

                                    {/* Grand Total */}
                                    {(lensData.lens_type_od || lensData.lens_type_os || isPhotochromicOD || isPhotochromicOS) && (
                                        <div style={{ textAlign: "right", fontWeight: 800, fontSize: 15, color: "#DC4C64", marginBottom: 8 }}>
                                            Grand Total: R {grandTotal.toFixed(2)}
                                        </div>
                                    )}

                                    <div className="mt-2">
                                        <button
                                            className="btn btn-danger px-4"
                                            onClick={handleSave}
                                            disabled={saving}
                                        >
                                            {saving
                                                ? <><span className="spinner-border spinner-border-sm me-1" />Saving...</>
                                                : <><i className="mdi mdi-content-save me-1" />Save</>
                                            }
                                        </button>
                                    </div>
                                </Form>
                            </CardBody>
                        </Card>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default TakeLenses;
